import type { ListParams } from '@nucleus-commerce/admin-kit/index-table';
import {
  getAdminV1StoresStoreIdSeoAudits,
  getAdminV1StoresStoreIdSeoIssues,
  postAdminV1StoresStoreIdSeoAudit,
  postAdminV1StoresStoreIdSeoIssuesIssueIdResolve,
  type GetAdminV1StoresStoreIdSeoIssues200,
  type SeoAudit,
  type SeoAuditQueued,
  type SeoIssue,
} from '@nucleus-commerce/api-client/admin';

/**
 * List params as `listParams` builds them from the route's search: `sort`, the flat filter params
 * (`severity=error,warn`, `status=open,resolved`), `cursor`, `limit`.
 */
export type SeoIssueListParams = ListParams;

/** SEO issues found by the store's audit, the audit runs, and a manual run. */
export const seoApi = {
  issues: (
    storeId: string,
    params: SeoIssueListParams,
  ): Promise<GetAdminV1StoresStoreIdSeoIssues200> =>
    getAdminV1StoresStoreIdSeoIssues({ storeId }, params),
  resolve: (storeId: string, issueId: string): Promise<SeoIssue> =>
    postAdminV1StoresStoreIdSeoIssuesIssueIdResolve({ storeId, issueId }),
  audits: (storeId: string): Promise<SeoAudit[]> =>
    getAdminV1StoresStoreIdSeoAudits({ storeId }).then((r) => r.items),
  runAudit: (storeId: string): Promise<SeoAuditQueued> =>
    postAdminV1StoresStoreIdSeoAudit({ storeId }),
};
